// extracted by mini-css-extract-plugin
export default {"sealsContainer":"sealsContainer___flupu","sealContainer":"sealContainer___hvetY"};